import { resolveFlavor } from '@/config/flavors'

const socialIconMap = {
  facebook: 'bi bi-facebook',
  instagram: 'bi bi-instagram',
  linkedin: 'bi bi-linkedin',
  youtube: 'bi bi-youtube'
}

const baseFooterContent = {
  topTagline: '',
  mainLogoAlt: 'Brand logo',
  panelLogoAlt: 'Brand logo',
  panelDescription: '',
  addressTitle: '',
  addressLines: [],
  socialLinks: [],
  appBadge: {
    href: '#',
    text: 'Get it on Google Play'
  },
  appBadgeCaption: '',
  contact: {
    title: 'Contact Us',
    items: []
  },
  columns: [],
  trustCards: [],
  paymentMethods: {
    title: 'Secure Payments',
    methods: []
  },
  newsletter: {
    title: '',
    placeholder: 'Enter your email',
    ctaLabel: 'Subscribe',
    submitHref: '#'
  },
  copyright: {
    year: new Date().getFullYear(),
    text: ''
  }
}

const footerByFlavor = {
  sanwariapghouse: {
    topTagline: 'Premium PG & Hostel Living in Delhi',
    mainLogoAlt: 'Sanwaria',
    panelLogoAlt: 'Sanwaria',
    panelDescription: 'Premium PG & Hostel Living in Delhi',
    socialLinks: [
      { label: 'Facebook', href: 'https://www.facebook.com/gopgmsapp/', iconClass: socialIconMap.facebook },
      { label: 'Instagram', href: 'https://www.instagram.com/gopgmsofficial/', iconClass: socialIconMap.instagram },
      { label: 'YouTube', href: 'https://www.youtube.com/channel/UCGiqWhKKhR3RE0Gz9T45K3Q', iconClass: socialIconMap.youtube }
    ],
    appBadge: {
      href: '#',
      text: 'Get it on Google Play'
    },
    appBadgeCaption: 'Manage booking & rent from phone',
    contact: {
      title: 'Contact Us',
      items: [
        { label: '+91 345 533 865', href: 'tel:+91345533865', iconClass: 'bi bi-telephone-fill' },
        {
          label: 'Book via WhatsApp',
          href: 'https://wa.me/91345533865',
          iconClass: 'bi bi-whatsapp',
          emphasize: true
        },
        { label: 'info@sanwariapg.com', href: 'mailto:info@sanwariapg.com', iconClass: 'bi bi-envelope-fill' },
        { label: '9 AM - 8 PM', iconClass: 'bi bi-clock-fill' }
      ]
    },
    columns: [
      {
        title: 'Our Properties',
        links: [
          { label: 'Sanwaria Sarita Vihar Boys PG', href: '#' },
          { label: 'Sanwaria Sarita Vihar Girls PG', href: '#' },
          { label: 'Sanwaria Jasola PG', href: '#' },
          { label: 'Sanwaria Okhla PG', href: '#' }
        ]
      },
      {
        title: 'Explore',
        links: [
          { label: 'Rooms & Pricing', href: '#' },
          { label: 'Amenities', href: '#' },
          { label: 'Photo Gallery', href: '#' },
          { label: 'How Booking Works', href: '#' },
          { label: 'Availability', href: '#' }
        ]
      },
      {
        title: 'Resources',
        links: [
          { label: 'About Sanwaria', href: '#' },
          { label: 'About Staff', href: '#' },
          { label: 'Reviews / Testimonials', href: '#' },
          { label: 'Contact Us', href: '#' }
        ]
      },
      {
        title: 'Legal & Policies',
        links: [
          { label: 'Terms & Conditions', href: '#' },
          { label: 'Privacy Policy', href: '#' },
          { label: 'Refund & Cancellation Policy', href: '#' }
        ]
      }
    ],
    trustCards: ['Verified Properties', 'Secure Stays'],
    paymentMethods: {
      title: 'Secure Payments',
      methods: ['UPI', 'Razorpay', 'Visa', 'RuPay']
    },
    newsletter: {
      title: 'Get Room Availability Updates',
      placeholder: 'Enter your email',
      ctaLabel: 'Subscribe',
      submitHref: '#'
    },
    copyright: {
      year: 2026,
      text: '© 2026 Sanwaria PG | All Rights Reserved'
    }
  },
  bookabed: {
    topTagline: 'Find and Book Verified PGs & Hostels Easily',
    mainLogoAlt: 'BookaBed',
    panelLogoAlt: 'BookaBed',
    panelDescription: 'Find and Book Verified PGs & Hostels Easily',
    socialLinks: [
      { label: 'Facebook', href: 'https://www.facebook.com/gopgmsapp/', iconClass: socialIconMap.facebook },
      { label: 'Instagram', href: 'https://www.instagram.com/gopgmsofficial/', iconClass: socialIconMap.instagram },
      { label: 'YouTube', href: 'https://www.youtube.com/channel/UCGiqWhKKhR3RE0Gz9T45K3Q', iconClass: socialIconMap.youtube }
    ],
    appBadge: {
      href: '#',
      text: 'Get it on Google Play'
    },
    appBadgeCaption: 'Manage bookings on the go',
    contact: {
      title: 'Contact Us',
      items: [
        { label: 'Call: +91 80109 42551', href: 'tel:+918010942551', iconClass: 'bi bi-telephone-fill' },
        { label: 'WhatsApp Support', href: 'https://wa.me/918010942551', iconClass: 'bi bi-whatsapp' },
        { label: 'gopgms9@gmail.com', href: 'mailto:gopgms9@gmail.com', iconClass: 'bi bi-envelope-fill' },
        { label: 'Support Time: 9 AM - 7 PM', iconClass: 'bi bi-clock-fill' }
      ]
    },
    columns: [
      {
        title: 'Quick Links',
        links: [
          { label: 'Home', href: '/' },
          { label: 'Search PG / Hostels', href: '/list-property' },
          // { label: 'List Your Property', href: '#' },
          { label: 'How It Works', href: '#' },
          { label: 'Pricing / Plans', href: '#' },
          { label: 'FAQ', href: '#' }
        ]
      },
      {
        title: 'Popular Cities',
        links: [
          { label: 'Bangalore', href: '#' },
          { label: 'Pune', href: '#' },
          { label: 'Hyderabad', href: '#' },
          { label: 'Mumbai', href: '#' },
          { label: 'Delhi', href: '#' },
          { label: 'Nagpur', href: '#' },
          { label: 'Amravati', href: '#' }
        ]
      },
      {
        title: 'Popular PGs / Properties',
        links: [
          { label: 'Top Rated PGs', href: '#' },
          { label: 'Recently Added', href: '#' },
          { label: 'Budget PGs', href: '#' },
          { label: 'Girls PG', href: '#' },
          { label: 'Boys PG', href: '#' }
        ]
      },
      {
        title: 'Legal & Trust',
        links: [
          { label: 'Terms & Conditions', href: '/terms' },
          { label: 'Privacy Policy', href: '/privacy-policy' },
          { label: 'Refund & Cancellation Policy', href: '/refund-cancellation-policy' },
          { label: 'User Agreement', href: '/user-agreement' },
          { label: 'Cookies Policy', href: '/cookies-policy' }
        ]
      }
    ],
    trustCards: [],
    paymentMethods: {
      title: 'Secure Payments',
      methods: ['Razorpay', 'UPI', 'Visa', 'Mastercard', 'RuPay']
    },
    newsletter: {
      title: 'Get PG Deals & Updates',
      placeholder: 'Enter your email',
      ctaLabel: 'Subscribe',
      submitHref: '#'
    },
    copyright: {
      year: 2026,
      text: '© 2026 BookaBed.in | Powered by Intend Technosoft Pvt Ltd'
    }
  },
  urbanstays: {
    topTagline: 'Smart | Healthy | Hygiene',
    mainLogoAlt: 'Urban Stays',
    panelLogoAlt: 'Urban Stays',
    panelDescription: 'Smart, healthy & hygienic PG accommodation',
    socialLinks: [
      { label: 'Facebook', href: 'https://www.facebook.com/', iconClass: socialIconMap.facebook },
      { label: 'Instagram', href: 'https://www.instagram.com/', iconClass: socialIconMap.instagram },
      { label: 'YouTube', href: 'https://www.youtube.com/', iconClass: socialIconMap.youtube }
    ],
    contact: {
      title: 'Contact Us',
      items: [
        { label: '+91 70908 34443', href: 'tel:+917090834443', iconClass: 'bi bi-telephone-fill' },
        { label: '+91 70908 34442', href: 'tel:+917090834442', iconClass: 'bi bi-telephone-fill' },
        { label: 'WhatsApp Support', href: 'https://wa.me/917090834443', iconClass: 'bi bi-whatsapp' },
        { label: 'info.urbanstays@gmail.com', href: 'mailto:info.urbanstays@gmail.com', iconClass: 'bi bi-envelope-fill' },
        { label: '6 AM - 9 PM', iconClass: 'bi bi-clock-fill' }
      ]
    },
    columns: [
      {
        title: 'Quick Links',
        links: [
          { label: 'Home', href: '/' },
          { label: 'Search Properties', href: '/list-property' },
          { label: 'About', href: '/about' },
          { label: 'Contact Us', href: '/contact' }
        ]
      },
      {
        title: 'Legal & Policies',
        links: [
          { label: 'Terms & Conditions', href: '/terms' },
          { label: 'Privacy Policy', href: '/privacy-policy' },
          { label: 'Refund & Cancellation Policy', href: '/refund-cancellation-policy' },
          { label: 'User Agreement', href: '/user-agreement' },
          { label: 'Cookies Policy', href: '/cookies-policy' }
        ]
      }
    ],
    trustCards: [],
    paymentMethods: {
      title: 'Secure Payments',
      methods: ['Razorpay', 'UPI', 'Visa', 'Mastercard', 'RuPay']
    },
    copyright: {
      year: 2026,
      text: '© 2026 Urban Stays | All Rights Reserved'
    }
  }
}

const deepMerge = (base, override = {}) => ({
  ...base,
  ...override,
  appBadge: {
    ...base.appBadge,
    ...(override.appBadge || {})
  },
  contact: {
    ...base.contact,
    ...(override.contact || {}),
    items: override.contact?.items || base.contact.items
  },
  paymentMethods: {
    ...base.paymentMethods,
    ...(override.paymentMethods || {}),
    methods: override.paymentMethods?.methods || base.paymentMethods.methods
  },
  newsletter: {
    ...base.newsletter,
    ...(override.newsletter || {})
  },
  copyright: {
    ...base.copyright,
    ...(override.copyright || {})
  },
  socialLinks: override.socialLinks || base.socialLinks,
  addressLines: override.addressLines || base.addressLines,
  columns: override.columns || base.columns,
  trustCards: override.trustCards || base.trustCards
})

export const resolveFooterContent = (hostname = '') => {
  const flavor = resolveFlavor(hostname)
  const flavorFooter = footerByFlavor[flavor.key] || {}

  return deepMerge(baseFooterContent, {
    ...flavorFooter,
    mainLogoSrc: flavor.logos.footer,
    panelLogoSrc: flavor.logos.footer,
    flavorKey: flavor.key
  })
}

export { baseFooterContent, footerByFlavor }
